import { render, staticRenderFns } from "./CredenciamentoFornecedorTermos.vue?vue&type=template&id=e888bdbc"
import script from "./CredenciamentoFornecedorTermos.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorTermos.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoFornecedorTermos.vue?vue&type=style&index=0&id=e888bdbc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports